import { ReactComponent as VerticalSpacingIcon } from 'assets/icons/vertical_spacing.svg';
import { SliderPopover } from 'modules/common/components/ToolbarPopover';
import { useTranslation } from 'react-i18next';
import { useEditor, useWidget } from 'widgets/sdk';

import { StatChartWidgetData } from '../StatChartWidget.types';

export const VerticalSpacingOption = () => {
  const { verticalSpacing, updateWidget } = useWidget<StatChartWidgetData>();
  const { boundingBox } = useEditor();
  const { t } = useTranslation('editor_widget_toolbar', {
    keyPrefix: 'statChartToolbar.verticalSpacing',
    useSuspense: false,
  });

  const label = t('label');

  const updateVerticalSpacing = (spacing: number) => {
    updateWidget({ verticalSpacing: spacing });

    // Update bb
    setTimeout(() => boundingBox.updateRect(), 0);
  };

  return (
    <SliderPopover
      value={verticalSpacing || 0}
      title={label}
      label={label}
      min={1}
      max={20}
      onChange={updateVerticalSpacing}
      icon={<VerticalSpacingIcon />}
      activeIconStyle={{ '& path': { fill: 'upgrade.blue.700' } }}
    />
  );
};
